import React, { useEffect, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import { IoMdOpen } from 'react-icons/io';
import { GetAll } from '../../../configurations/crud/doctorsFastNoteCurd';
import StatusContainer from '../../controls/StatusContainer';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import moment from 'moment';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';

export default function PatientHistory({ currentData }) {
    const initValues = {
        Mobile: "",
        PageNo: 1,
        PageSize: 5,
        SearchTerm: "",
    }
    const { start, end } = useGlobalLoader()
    const [search, setSearch] = useState(initValues);
    const toast = useToast()
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [loding, setLoding] = useState(false)
    const [userData, setUserData] = useState([]);
    const [searchDebounce, setSearchDebounce] = useDebounce("", 700);
    const [searchTerm, setSearchTerm] = useState("");
    const [patientDetails, setPatientDetails] = useState();

    useEffect(() => {
        if (currentData)
            onSearch()
    }, [search])

    const OnPageChange = (e) => {
        const { value } = e.target;
        setSearch({ ...search, PageNo: value })
    }

    const onSearch = () => {
        GetConfirmedHistoryByMobileNo({ ...search, Mobile: currentData.mobile })
    }


    const GetConfirmedHistoryByMobileNo = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetConfirmedHistoryByMobileNo({ ...params, Mobile: currentData.mobile }).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setUserData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setUserData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setUserData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }
    return (
        <>
            <div className='w-full'>
                <dl class="grid max-w-screen-xl grid-cols-1 gap-4 p-2 mx-auto text-gray-900 sm:grid-cols-2">
                    {currentData ?
                        <>
                            <div class="flex flex-col items-center justify-center">
                                <dd class="text-gray-500 ">Number</dd>
                                <dt class="mt-2 text-xl font-bold flex items-center justify-center gap-2">
                                    <span>{currentData.confirmedAllotedNumber}{currentData.confirmedAllotedNumber != currentData.opdNumberAlloted && <span className='text-sm font-normal'>/{currentData.opdNumberAlloted}</span>}</span>
                                    <StatusContainer bg={ETypeBg(currentData.type)} text={GetETypeName(currentData.type)} />
                                </dt>
                            </div>
                            <div class="flex flex-col items-center justify-center">
                                <dd class="text-gray-500 ">Name <span className='font-normal text-[9px]'>({GetEGenderName(currentData.gender)})</span></dd>
                                <dt class="mt-2 text-xl font-bold">{currentData.patientName.toUpperCase()}</dt>
                            </div>
                            <div class="flex flex-col items-center justify-center">
                                <dt class="text-gray-500 ">Ref No.</dt>
                                <dd class="mt-2 text-xl font-bold">{currentData.id}{currentData.registeredIdForRef && "/" + currentData.registeredIdForRef}</dd>
                            </div>

                            <div class="flex flex-col items-center justify-center">
                                <dt class="text-gray-500">Details</dt>
                                <dd class="mt-2 text-xl font-bold text-red-700"><span className='text-sm font-normal'>Age:</span> {currentData.age}<span className='text-sm font-normal'>Y</span> <span className='text-sm font-normal'>BP:</span>{currentData.bloodPressure} <span className='text-sm font-normal'>BG:</span>{currentData.bloodGroup} <span className='text-sm font-normal'>W:</span>{currentData.weight}<span className='text-sm font-normal'>Kg</span> </dd>
                            </div>
                            <div class="flex flex-col items-center justify-center">
                                <dt class="text-gray-500">Address</dt>
                                <dd class="mt-2 text-xl font-bold "> {currentData.patientAddress}</dd>
                            </div>
                            <div class="flex flex-col items-center justify-center">
                                <dt class="text-gray-500">Phone</dt>
                                <dd class="mt-2 text-xl font-bold">{currentData.mobile}</dd>
                            </div>
                            {currentData.note ?
                                <div class="flex mt-4 flex-row items-center justify-center">
                                    <dt class="text-sm font-semibold">Note:-</dt>
                                    <dd class="text-gray-500 text-sm pl-1">{currentData.note}</dd>
                                </div>
                                :
                                <>
                                </>
                            }
                        </>
                        :
                        <>
                            <div class="px-2 py-2 font-semibold"> Please Start OPD</div>
                        </>
                    }
                </dl>
            </div>
            <div class="text-gray-700">
                <div class="text-center text-2xl">
                    <div class="px-4 py-2 font-semibold"></div>
                    <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
                        <div className='overflow-x-auto'>
                            <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                                <thead class="text-xs text-gray-700 uppercase bg-gray-200 ">
                                    <tr>
                                        <th scope="col" class="px-3 py-3">
                                            Date
                                        </th>   <th scope="col" class="px-3 py-3">
                                            Center
                                        </th>
                                        <th scope="col" class="px-3 py-3">
                                            Name
                                        </th>
                                        <th scope="col" class="px-3 py-3">
                                            Comment
                                        </th>
                                        <th scope="col" class="px-3 py-3">
                                            Note
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        userData.length > 0 ?
                                            userData.map((item, index) =>
                                                <tr class="bg-white border-b  hover:bg-gray-100 ">
                                                    <td class="px-3 py-2 text-nowrap">
                                                        {moment(item.onDate).format("DD-MM-YYYY")}
                                                    </td>
                                                    <td class="px-3 py-2 text-nowrap">
                                                        {item.opdCenter.centerName}
                                                    </td>
                                                    <td class="px-3 py-2  text-nowrap">
                                                        {item.patientName} (BP:{item.bloodPressure} W:{item.weight}Kg)
                                                    </td>
                                                    <td class="px-3 py-2 text-nowrap">
                                                        {item.acceptedWithComment ? item.acceptedWithComment : "N/A"}
                                                    </td>
                                                    <td class="flex items-center px-3 py-2 text-nowrap">
                                                        {item.note}
                                                    </td>

                                                </tr>
                                            )
                                            :
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                <td colSpan={5} class="px-3 py-2">
                                                    <Empty>
                                                        No Items Found.
                                                    </Empty>
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Paging>

                    <div class="pb-4"></div>
                </div>
            </div>
        </>
    )
}

